// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"9d04f9e7","457":"5f07cd3a","695":"1e271ced"}[chunkId] + ".chunk.css";
};